export default __webpack_public_path__ + "static/media/gmail.d765005c.png";